import { useEffect, useRef, useState } from 'react'
import { activateUpdateWhenSafe } from 'src/pwa'

type Props = {
  hasUnsavedChanges: boolean
}

export function AppUpdateManager({ hasUnsavedChanges }: Props) {
  const [updateReady, setUpdateReady] = useState(false)
  const lastHiddenAt = useRef<number | null>(null)

  useEffect(() => {
    const onUpdateReady = () => {
      console.log("AppUpdateManager onUpdateReady");
      setUpdateReady(true)
    }

    window.addEventListener('app:update-ready', onUpdateReady)

    return () => {
      window.removeEventListener('app:update-ready', onUpdateReady)
    }
  }, [])

  useEffect(() => {
    const onVisibilityChange = async () => {
      if (document.hidden) {
        lastHiddenAt.current = Date.now()
        return
      }

      if (!updateReady) return
      if (hasUnsavedChanges) return

      const hiddenDuration = lastHiddenAt.current
        ? Date.now() - lastHiddenAt.current
        : 0

      // Si l'utilisateur revient après 2 minutes, on applique la version à jour
      if (hiddenDuration > 2 * 60 * 1000) {
        await activateUpdateWhenSafe()
      }
    }

    document.addEventListener('visibilitychange', onVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [updateReady, hasUnsavedChanges])

  return null
}
